import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import {
  Checklist,
  ChecklistCreateParams,
  ChecklistFindAllParams,
} from '../core/type';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { ChecklistService } from '../core/service';
import { User } from '../../user/core/type';

@Injectable()
export class ChecklistApiService implements ChecklistService {
  private readonly defaultUrl = `${environment.apiHost}/checklists`;

  constructor(private httpClient: HttpClient) {}

  update(id: number, data: Omit<Checklist, 'id'>): Observable<void> {
    return this.httpClient.patch<void>(`${this.defaultUrl}/${id}`, data);
  }

  getById(id: number): Observable<Checklist> {
    return this.httpClient.get<Checklist>(`${this.defaultUrl}/${id}`);
  }

  findAll(
    filter?: ChecklistFindAllParams | undefined
  ): Observable<PaginatedResponse<Checklist>> {
    return this.httpClient.get<PaginatedResponse<Checklist>>(this.defaultUrl, {
      params: { ...filter },
    });
  }

  create(data: Omit<ChecklistCreateParams, 'id'>) {
    return this.httpClient.post<void>(this.defaultUrl, data);
  }

  delete(id: number): Observable<void> {
    throw new Error('Method not implemented.');
  }
}
